import React from "react";
import ProjectImagesSwiper from "../../swiper/ProjectImagesSwiper.jsx";
import {l} from "../../../../lang/index.jsx";

export default function Single({data, lang, uiMap})
{

    const descriptionTitle = uiMap?.['single-description-title']?.[lang] || l('single-description-title', lang);
    const toolsTitle = uiMap?.['single-tools-title']?.[lang] || l('single-tools-title', lang);
    const DATA = Array.isArray(data?.images) ? data.images : [];

    return (
        <div className="section section-single-project">
            <div className="single-project-inner">
                <div className="single-project-content">
                    {typeof data?.content === "string" && data.content.trim() !== "" ? (
                        <div className="content-description">
                            <h2 className="h2">{descriptionTitle}</h2>
                            <p className="paragraph" data-bg-color="transparent" data-fg-color="#fcfbe9"
                                dangerouslySetInnerHTML={{ __html: data.content.replace(/\\n|\n/g, '<br>') }}
                            />
                        </div>
                    ) : null}

                    {/* Rendu conditionnel et robuste des outils : gère tableau d'objets {outil: '...'} ou tableau de chaînes */}
                    {Array.isArray(data?.outils) && data.outils.length > 0 ? (
                        <div className="content-tools">
                            <h2 className="h2">{toolsTitle}</h2>
                            <ul className="tools-list">
                                {data.outils.map((o, idx) => {
                                    const label = typeof o === 'string' ? o : (o && (o.outil || o.name || o.label) ? (o.outil || o.name || o.label) : String(o));
                                    return <li key={idx}>{label}</li>;
                                })}
                            </ul>
                        </div>
                    ) : null}
                </div>

                <ProjectImagesSwiper lang={lang} currentImages={DATA} titleProject={data.title} currentSlug={data?.slug} uiMap={uiMap} />
            </div>

        </div>
    )
}